import { ACADEMIC_PERFORMANCE_EVALUATION_TYPES } from '@src/modules/evaluacion-desempeño-academico/domain/entities/Evaluation'
import EvaluationDetails from '../../evaluacion-desempeño-academico/domain/entities/EvaluationDetails'

class RendimientoProfesionalismo {
  constructor(id = null, detalles = new EvaluationDetails(), reactivos = []) {
    this.id = id
    this.tipo = ACADEMIC_PERFORMANCE_EVALUATION_TYPES.PERFORMANCE_AND_PROFESSIONALISM
    this.detalle = detalles
    this.reactivos = reactivos
  }

  static fromDto(rendimientoProfesionalismoDto) {
    const rendimientoProfesionalismo = new RendimientoProfesionalismo(
      rendimientoProfesionalismoDto.id,
      {
        status: rendimientoProfesionalismoDto.fk_idCatEstatusEvaluacion,
        idMunicipio: rendimientoProfesionalismoDto.fk_idCatMunicipio,
        municipio: rendimientoProfesionalismoDto.CatMunicipio,
        idEvaluado: rendimientoProfesionalismoDto.fk_idPersonal,
        evaluado: { ...rendimientoProfesionalismoDto.Personal },
        idEvaluador: rendimientoProfesionalismoDto.fk_idPersonalEvaluador,
        evaluador: { ...rendimientoProfesionalismoDto.PersonalEvaluador },
        fechaAplicacion: rendimientoProfesionalismoDto.fechaAplicacion,
        fechaFin: rendimientoProfesionalismoDto.fechaFin,
        fechaInicial: rendimientoProfesionalismoDto.fechaInicial,
        idResultado: rendimientoProfesionalismoDto.fk_idResultado,
        institucionSeguridadAspirada: rendimientoProfesionalismoDto.institucionSeguridadAspira,
        puestoAspirado: rendimientoProfesionalismoDto.aspiranteAlPuesto,
        observaciones: rendimientoProfesionalismoDto.observaciones,
      },
      rendimientoProfesionalismoDto.frecuenciasMedicion.map((item) => ({
        id: item.id,
        idFrecuencia: item.fk_idCatFrecuencia,
        idReactivo: item.fk_idReactivoEvaluacion,
        estatus: true,
      }))
    )

    return { ...rendimientoProfesionalismo }
  }
}

export default RendimientoProfesionalismo
